function validateCardNumber(cardNumber: string) {
  const value = cardNumber.replace(/[^\d]/g, '');
  let message = '';
  let success = false;

  if (!value.length) {
    message = '카드번호 입력은 필수입니다.';
  } else if (value.length < 14 || value.length > 16) {
    message = '정확한 카드번호를 입력해 주세요.';
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}

export default validateCardNumber;
